import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=c45e50c8&"
import script from "./Ship.vue?vue&type=script&lang=js&"
export * from "./Ship.vue?vue&type=script&lang=js&"
import style0 from "./Ship.vue?vue&type=style&index=0&id=c45e50c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports